// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a7903e81","659":"0364d3a5"}[chunkId] + ".chunk.js";
};